import { useMemo } from 'react'

import { Typography } from '@mui/material'
import { VideoBlob } from '@nativewaves/nw-cloud-sdk/content'
import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { CopyId } from '@shared/components/Table/Fields'
import { DATE_TIME_FORMAT } from '@shared/utils/support'

export const useColumns = () => {
  const { t } = useTranslation(['common', 'entity', 'domain'])

  return useMemo<ColumnDef<VideoBlob>[]>(
    () => [
      {
        accessorFn: (row) => (row.storeId?.length ? row.storeId : t('noNameSet')),
        id: '_name',
        header: t('name'),
        meta: {
          sizing: {
            px: 2,
            minWidth: 300,
          },
        },
        cell: ({ getValue }) => (
          <Typography variant="inherit" noWrap>
            {getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'creationTime',
        header: t('domain:Workspace.Video.creationTime'),
        meta: {
          sizing: {
            minWidth: 300,
            px: 1,
          },
        },
        cell: ({ getValue }) => (
          <Typography variant="inherit" noWrap>
            {format(new Date(getValue<string>()), DATE_TIME_FORMAT)}
          </Typography>
        ),
      },
      {
        accessorKey: 'id',
        header: t('id'),
        meta: {
          sizing: {
            minWidth: 480,
            maxWidth: 560,
          },
        },
        cell: ({ getValue }) => <CopyId id={getValue<string>()} />,
      },
    ],
    [t],
  )
}
